// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';

const initialValues = {
    name: '',
    ext: '',
    data: '',
};

const initialErrors = {
    name: '',
    ext: '',
    data: ''
};

let abortController;

const DialogAdd = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.post('/api/files/text/', values, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    props.onOk(data);
                    clear();
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.name = (data.name) ? data.name[0] : '';
                    _errors.ext = (data.ext) ? data.ext[0] : '';
                    _errors.data = (data.data) ? data.data[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
    };

    return (
        <DialogForm id="files-dialog-add" title="Добавление файла" label="Добавить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <Form values={values} onChange={handleChange} errors={errors} onFocus={handleFocus}/>
        </DialogForm>
    );
};

DialogAdd.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogAdd;
Component = withFetch(Component);

export default Component;
